// extracted by mini-css-extract-plugin
export default {"advertCardFooter":"c-a_ci","advertCardFooter__row":"c-a_cj","advertCardFooter__name":"c-a_ck","advertCardFooter__price":"c-a_cl","advertCardFooter__age":"c-a_cm"};